/* eslint-disable max-len */
import { Auth } from "aws-amplify";
import axios from "axios";
import { handleSessionError } from '../CommonMethods/handleSessionError'

const { baseURL } = require("../config");


async function login(email, password, browserId) {
    let payload = {
        user_name: email,
        password: password,
        browser_id: browserId.toString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}organization-users/login`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function resetPassword(email, payload) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}organization-users/reset-password/${email}`, payload, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}


async function verifyPreference(payload) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}organization-users/verify-preference`, payload, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function verifyOtp(payload) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}organization-users/preference`, payload, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function preferenceList() {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.get(`${baseURL}organization-users/preference`, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function trustMyBrowser(body) {
    const idToken = sessionStorage.getItem("IdToken");
    const id = sessionStorage.getItem("id");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}organization-users/trust-browser/${id}`, body, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function sendOtptoPreference(preference_id) {
    const sessionToken = sessionStorage.getItem('session_token');
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}organization-users/login/send-otp`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function resendOtp(preference_id) {
    const sessionToken = sessionStorage.getItem("session_token");
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        type: "resend-otp",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}organization-users/login/send-otp`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function verifyLoginOtp(otp) {
    const sessionToken = sessionStorage.getItem("verify_otp_session_token");
    let payload = {
        session_token: sessionToken,
        otp: otp,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}organization-users/login/verify-otp`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function logout() {
    const idToken = sessionStorage.getItem("IdToken");
    const refreshToken = sessionStorage.getItem('RefreshToken')
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token": refreshToken,
        "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,


    }
    try {
        const data = await axios.post(`${baseURL}organization-users/logout`, payload, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}


async function deletePreference(_id) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.delete(`${baseURL}organization-users/delete-preference/${_id}`, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function forgotPasswordLink(username) {
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const url = `${baseURL}organization-users/forgot-password-send-link/${username}?timezone=${encodeURIComponent(timezone)}`;
        const data = await axios.post(url);
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function forgotPassword(body) {
    try {
        const data = await axios.patch(`${baseURL}organization-users/forgot-password-verify`, body);
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}


async function RefreshToken() {
    const idToken = sessionStorage.getItem("IdToken");
    const refreshToken = sessionStorage.getItem("RefreshToken");
    const body = {
        refresh_token: refreshToken
    }
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}organization-users/refresh-token`, body, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function DuplicateLogout() {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken')
    const refreshToken = localStorage.getItem("RefreshToken")!==null?localStorage.getItem("RefreshToken"):sessionStorage.getItem('RefreshToken')
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token" : refreshToken,
        "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}organization-users/logout?type=clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function CancelDuplicatelogin() {
    let payload = {
        user_name: sessionStorage.getItem('email'),
        user_type: "organization-user",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}users/capture-log`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function DuplicateTabClose() {
    const idToken = sessionStorage.getItem('IdToken');
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}users/clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

export const userService = {
    login,
    resetPassword,
    verifyPreference,
    verifyOtp,
    preferenceList,
    sendOtptoPreference,
    verifyLoginOtp,
    logout,
    trustMyBrowser,
    deletePreference,
    forgotPasswordLink,
    forgotPassword,
    resendOtp,
    RefreshToken,
    DuplicateTabClose,
    DuplicateLogout,
    CancelDuplicatelogin,
}
